import React from "react";
//Page components

//Animations
import {motion} from 'framer-motion';
import {pageAnimation} from '../animation';


const Avisos = () => {
	return (
		<motion.div variants={pageAnimation} initial="hidden" animate="show" exit="exit">	
			{/* <AboutSection />
			<ServicesSection />
            <FaqSection /> */}
            <h1>Avisos</h1>
		</motion.div>
	);
};

export default Avisos;